export const SCHEDULE_STATUSES = [
    { id: "SCHEDULED", label: "scheduled", color: "#29B3BC" },
    { id: "COMPLETED", label: "completed", color: "#33B950" },
];
